var map = {
	"./partner1.svg": 8200,
	"./partner2.svg": 5064,
	"./partner3.png": 168,
	"./partner4.gif": 136,
	"./partner5.svg": 8068,
	"./partner6.jpeg": 3712,
	"./partner7.svg": 6724,
	"./partner8.png": 7556,
	"./partner9.jpeg": 688
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4212;